import React, { useState } from "react";
import axios from "axios";

const Register = ({ closeModal, setLoggedInUser }) => {
  const [passwordMatchError, setPasswordMatchError] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState("");

  const handlePasswordChange = (event) => {
    const password = event.target.value;

    // Check password strength based on length and character types
    let strength = "Weak";
    if (password.length >= 8) {
      strength = "Moderate";
    }
    if (password.match(/[a-z]/) && password.match(/[A-Z]/) && password.match(/[0-9]/)) {
      strength = "Strong";
    }
    if (password.match(/[a-z]/) && password.match(/[A-Z]/) && password.match(/[0-9]/) && password.match(/[@$!%*?&]/)) {
      strength = "Very Strong";
    }

    setPasswordStrength(strength);
  };

  const registerUser = (event) => {
    event.preventDefault();
    const name = event.target.elements.registerName.value;
    const email = event.target.elements.registerEmail.value;
    const password = event.target.elements.registerPassword.value;
    const confirmPassword = event.target.elements.registerConfirmPassword.value;

    if (password !== confirmPassword) {
      setPasswordMatchError(true);
      return;
    }

    // Additional password complexity requirements (customize as needed)
    if (passwordStrength === "Weak" || passwordStrength === "Moderate") {
      alert("Password does not meet complexity requirements.");
      return;
    }

    axios
      .post("http://localhost:4000/api/auth/register", { name, email, password })
      .then((response) => {
        const { success, message } = response.data;
        if (success) {
          alert(message);
          closeModal();
          setLoggedInUser(name);
        } else {
          alert(message);
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 409) {
          alert(error.response.data.message); // Email already registered
        } else {
          console.error(error);
          alert("Failed to register user: " + error.message);
        }
      });
  };

  return (
    <form id="registerForm" onSubmit={registerUser}>
      <div className="form-group">
        <input
          type="text"
          className="form-control"
          id="registerName"
          placeholder="Name"
          required
        />
      </div>
      <div className="form-group">
        <input
          type="email"
          className="form-control"
          id="registerEmail"
          placeholder="Email"
          required
        />
      </div>
      <div className="form-group">
        <input
          type="password"
          className={`form-control ${passwordMatchError ? 'is-invalid' : ''}`}
          id="registerPassword"
          placeholder="Password"
          onChange={handlePasswordChange}
          required
        />
      </div>
      <div className="form-group">
        <input
          type="password"
          className={`form-control ${passwordMatchError ? 'is-invalid' : ''}`}
          id="registerConfirmPassword"
          placeholder="Confirm Password"
          required
        />
        {passwordMatchError && <div className="invalid-feedback">Passwords do not match.</div>}
        {passwordStrength && (
          <div className="mt-2">
            Password strength: <span className={`password-strength-${passwordStrength}`}>{passwordStrength}</span>
          </div>
        )}
      </div>
      <button type="submit" className="btn btn-primary btn-block w-100">
        Register
      </button>
    </form>
  );
};

export default Register;
